import ErrorImage from "./404.png";
import { useNavigate } from "react-router-dom";

const ErrorPage = () => {
  const navigate = useNavigate();

  const handleClickBackToHomepage = () => {
    navigate("/uebersicht");
  };

  return (
    <>
      <main className="flex justify-center items-center h-screen">
        <div className="flex-row">
          <h1 className="flex items-center justify-center text-blue_royal select-none text-2xl m-1 p-2 w-full text-center">
            Ups... Something has gone wrong.
          </h1>
          <img src={ErrorImage} alt="Grumpycat-404"></img>
          <button
            className="w-full mt-5 bg-gray-600 h-7 p-0 rounded-none border-none text-lg text-white cursor-pointer hover:bg-gray-700"
            onClick={handleClickBackToHomepage}
          >
            Zurück zur Homepage
          </button>
        </div>
      </main>
    </>
  );
};

export default ErrorPage;
